module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<dl class="stepped zero">\n    <dt>\n        <label for="type-select">\n            ' +
((__t = ( i18next.t('import_organization_data.category') )) == null ? '' : __t) +
'\n        </label>\n    </dt>\n    <dd>\n        <select class=\'text\' id=\'type-select\'>\n            <option value="contracts">\n                ' +
((__t = ( i18next.t('glossary.contracts').capitalize() )) == null ? '' : __t) +
'\n            </option>\n            <option value="indicators">\n                ' +
((__t = ( i18next.t('import_organization_data.historic_indicator_data') )) == null ? '' : __t) +
'\n            </option>\n            <option value="objectives">\n                ' +
((__t = ( i18next.t('glossary.objectives').capitalize() )) == null ? '' : __t) +
'\n            </option>\n            <option value="utilities">\n                ' +
((__t = ( i18next.t('glossary.utilities').capitalize() )) == null ? '' : __t) +
'\n            </option>\n        </select>\n    </dd>\n\n    <div>\n        <p>\n            <span id="sample-instruction">\n                ' +
((__t = ( i18next.t('import_organization_data.sample_file_instruction', { category: `<b>
                    ${i18next.t('glossary.contracts')}</b>`,
                    interpolation: { escapeValue: false }
                    }) )) == null ? '' : __t) +
'\n            </span>\n            <a id=\'sample-link\' style=\'font-weight:bold;color:#8bc53f\'\n                href=\'' +
((__t = ( WiseMetering.apiUrl )) == null ? '' : __t) +
'/static/example_contracts.csv\' target=\'_blank\'>\n                ' +
((__t = ( i18next.t('import_organization_data.here') )) == null ? '' : __t) +
'\n            </a>.\n        </p>\n        <b>\n            ' +
((__t = ( i18next.t('organizations.configuration.important_notes') )) == null ? '' : __t) +
'\n        </b>\n        <ul id="import-notes">\n        </ul>\n        <br />\n        <div id="errors" style="color: red; max-height: 120px; overflow-y: auto;"></div>\n    </div>\n\n    <dt>\n        <label>\n            ' +
((__t = ( i18next.t('common.file').capitalize() )) == null ? '' : __t) +
'\n        </label>\n    </dt>\n    <dd>\n        <input accept=".csv" class="text" id="file" style="width: calc(100% - 5px);" type="file" />\n    </dd>\n</dl>';

}
return __p
}